export enum SetExerciseSubmissionState {
    RESET,

    SET_NAME_EN,
    SET_ALIASES_EN,
    SET_DESCRIPTION_EN,
    SET_NOTES_EN,
    SET_CATEGORY,
    SET_EQUIPMENT,
    SET_PRIMARY_MUSCLES,
    SET_MUSCLES_SECONDARY,
    SET_VARIATION_ID,
    SET_NEW_VARIATION_BASE_ID,
    SET_LANGUAGE,
    SET_NAME_I18N,
    SET_ALIASES_I18N,
    SET_DESCRIPTION_I18N,
    SET_NOTES_I18N,
    SET_IMAGES
}
